export type BenefitDataType = {
  title: string
  description: string
  icon: string
}

export const BENEFITS_DATA: BenefitDataType[] = [
  {
    title: 'One-on-one classes',
    description:
      'Teach only one child at a time for an engaging teaching experience.',
    icon: 'one-on-on',
  },
  {
    title: 'Flexible schedule',
    description: 'Pick your work hours and teach only when you want to teach. ',
    icon: 'flexible',
  },
  {
    title: 'Teach from anywhere',
    description:
      'Say goodbye to daily commutes and teach classes from anywhere.',
    icon: 'anywhere',
  },
  {
    title: 'Great earnings',
    description:
      'Get the best compensation in the industry with lots of extra incentives.',
    icon: 'earing',
  },
]

export type ThirdFoldDataType = {
  title: string
  description: string
  icon: string
}

export const THIRD_FOLD_DATA: ThirdFoldDataType[] = [
  {
    title: 'Make your passion pay',
    description:
      'If you are passionate about coding, teaching kids to code is a great way to increase your   while doing what you love.',
    icon: 'make-your-passion-pay',
  },
  {
    title: 'Make an impact',
    description:
      'Coding is the skill of the future. By teaching kids to code, you will empower them to be successful and create a better future.',
    icon: 'make-an-impact',
  },
  {
    title: 'Build lifelong relationships',
    description:
      'As a teacher, you will touch the lives of hundreds of children across the world and build lifelong relationships with students and their families.',
    icon: 'build-lifelong-relationships',
  },
]

export type UnmatchedEarningCardDataType = {
  title: string
  description: string
  icon: string
}

export const UNMATCHED_EARNING_CARD_DATA: Record<
  string,
  UnmatchedEarningCardDataType[]
> = {
  IN: [
    {
      title: 'Get paid per class',
      description:
        'As a teacher, you will get paid for every one-hour class you successfully complete. The more classes you teach, the more you earn.',
      icon: 'get-paid-per-class',
    },
    {
      title: 'Earn ₹50K a month',
      description:
        'We offer some of the most attractive compensation to our teachers who can make anywhere around ₹50,000 every month.',
      icon: 'earn',
    },
    {
      title: 'Attractive incentives',
      description:
        'We offer lots of opportunities to increase your income through various incentives, referral program, and mentorships.',
      icon: 'attractive-incentives',
    },
    {
      title: 'Career growth plan',
      description:
        'Gain experience and grow as a teacher along a clearly defined career progression path with great rewards for performance and leadership.',
      icon: 'career-growth-plan',
    },
  ],
  US: [
    {
      title: 'Get paid per class',
      description:
        'As a teacher, you will get paid for every one-hour class you successfully complete. The more classes you teach, the more you earn.',
      icon: 'get-paid-per-class',
    },
    {
      title: 'Earn $1K a month',
      description:
        'We offer some of the most attractive compensation to our teachers who can make anywhere around $1,000 every month.',
      icon: 'earn',
    },
    {
      title: 'Attractive incentives',
      description:
        'We offer lots of opportunities to increase your income through various incentives, referral program, and mentorships.',
      icon: 'attractive-incentives',
    },
    {
      title: 'Career growth plan',
      description:
        'Gain experience and grow as a teacher along a clearly defined career progression path with great rewards for performance and leadership.',
      icon: 'career-growth-plan',
    },
  ],
}

export type AllSupportYouNeedDataType = {
  title: string
  description: string
  icon: string
}

export const ALL_THE_SUPPORT_YOU_NEED_CARD_DATA: AllSupportYouNeedDataType[] = [
  {
    title: 'State-of-the-art teaching platform',
    description:
      'Our platform enables an immersive teaching and learning experience with in-built video. The platform makes teaching easy with all teaching aids, lesson plans, schedules at your fingertips.',
    icon: 'state-of-the-art-teaching-platform',
  },
  {
    title: 'Thriving community of K-12 students',
    description:
      "Our vast community of K-12 students is always keen to learn and eager to develop their coding skills. So you'll always find a student when you want to teach.",
    icon: 'thriving-community-of-K-12-students',
  },
  {
    title: 'Unique curriculum and lesson plans',
    description:
      "Our curriculum makes teaching code fun for students and teachers alike. We will also give you in-depth lesson plans to guide the child's code-learning journey.",
    icon: 'unique-curriculum-and-lesson-plans',
  },
  {
    title: 'Training and certification',
    description:
      'All our teachers undergo extensive training on procedures and curriculum to make sure we meet the highest standards and help you grow as a teacher.',
    icon: 'training-and-certification',
  },
]

export type EligibilityCriteriaForTeachersCardDataType = {
  title: string
  description: string
  icon: string
}

export const ELIGIBILITY_CRITERIA_FOR_TEACHERS_CARD_DATA: EligibilityCriteriaForTeachersCardDataType[] = [
  {
    title: "Bachelor's degree",
    description:
      "A bachelor's degree in a technical field is a minimum requirement. A degree in computer science, IT, or related fields is preferred.",
    icon: "bachelor's-degree",
  },
  {
    title: 'Recent graduates',
    description:
      'Freshers with a technical degree are always welcome. We offer training and certification to launch your career as a coding teacher.',
    icon: 'recent-graduates',
  },
  {
    title: 'Teaching experience',
    description:
      'Teaching experience and especially experience teaching coding will increase your chances of successfully becoming a teacher.',
    icon: 'teaching-experience',
  },
  {
    title: 'Coding experience',
    description:
      'Hands-on coding experience in a professional setting will also be an added advantage as long as you meet the other basic requirements.',
    icon: 'coding-experience',
  },
]

export type ClassroomSetupCardDataType = {
  title: string
  description: string
  icon: string
}

export const CLASS_ROOM_SETUP_CARD_DATA: ClassroomSetupCardDataType[] = [
  {
    title: 'Laptop or desktop',
    description:
      "You'll need a desktop or a laptop to be a able to conduct classes. Our platform do not support mobile phones or tablets.",
    icon: 'laptop-or-desktop',
  },
  {
    title: 'Fast internet',
    description:
      "You'll need a fast and stable internet connection to ensure a smooth teaching and learning experience.",
    icon: 'fast-internet',
  },
  {
    title: 'Webcam',
    description:
      "You'll need a high-definition webcam to make sure the students can clearly see and understand you.",
    icon: 'webcam',
  },
  {
    title: 'Microphone',
    description:
      'The students need to hear what you are saying in order to understand you. So make sure you use a crisp sounding microphone.',
    icon: 'microphone',
  },
]

export const DIVERSE_TEACHER_STATS = [
  {
    stat: '95%',
    title: 'Computer science graduates',
  },
  {
    stat: '91%',
    title: 'Female teachers',
  },
  {
    stat: '7+',
    title: 'years coding experience on average',
  },
  {
    stat: '10+',
    title: 'Coding languages known per teacher',
  },
]
